/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { ReactComponent as FamilySvg } from '../../../assets/icons/speak-doctor/family.svg';
import SliderQuestion from '../../../components/mobile/speak-doctor/SliderQuestion';
import TextAreaQuestion from '../../../components/mobile/speak-doctor/TextAreaQuestion';

const mobileNutritionRoutes = [
  {
    id: '1',
    path: '/speak-doctor/nutrition/how-many-people-live',
    component: (props) => <SliderQuestion {...props} />,
    props: {
      fieldName: 'HowManyPeopleDoYouLiveWith',
      prevRoutePath: '/speak-doctor',
      nextRoutePath: '/speak-doctor/nutrition/nutrition-days',
      textPrevHeaderPath: 'speak-doctor:nutrition.questionFirst.previousPage',
      title: 'speak-doctor:nutrition.questionFirst.title',
      question: 'speak-doctor:nutrition.questionFirst.question',
      isLastQuestion: false,
      sliderMinValue: 0,
      sliderMaxValue: 30,
      svgIcon: () => <FamilySvg />,
    },
  },
  {
    id: '2',
    path: '/speak-doctor/nutrition/nutrition-days',
    component: (props) => <SliderQuestion {...props} />,
    props: {
      fieldName: 'HowOftenFeelQualityFood',
      prevRoutePath: '/speak-doctor/nutrition/how-many-people-live',
      nextRoutePath: '/speak-doctor/nutrition/nutrition-issues',
      textPrevHeaderPath: 'speak-doctor:nutrition.questionTwo.previousPage',
      title: 'speak-doctor:nutrition.questionTwo.title',
      question: 'speak-doctor:nutrition.questionTwo.question',
      isLastQuestion: false,
      labelSlider: "days",
      sliderMinValue: 1,
      sliderMaxValue: 7
    },
  },
  {
    id: '3',
    path: '/speak-doctor/nutrition/nutrition-issues',
    component: (props) => <TextAreaQuestion {...props} />,
    props: {
      fieldName: 'IssueToDiscussWithDoctor',
      prevRoutePath: '/speak-doctor/nutrition/nutrition-days',
      nextRoutePath: '',
      textPrevHeaderPath: 'speak-doctor:nutrition.questionThree.previousPage',
      title: 'speak-doctor:nutrition.questionThree.title',
      question: 'speak-doctor:nutrition.questionThree.question',
      isLastQuestion: true,
    },
  },
];

export const getMobileNutritionRoutes = () => mobileNutritionRoutes;
